import { SidePanelContext } from "components/SidePanel/SidePanelContext";
import React, { useContext } from "react";
import { FormSection, InPageEditableSectionField, Section, TwoColumnInPageEditableSectionField } from "../types";
import { InPageEditableFieldSidePanelNarrow, InPageEditableFieldSidePanelWide } from "./InPageEditableFieldSidePanel";
import { convertSectionsToSidePanel, flattenTwoColumnFields } from "./convertSectionsToSidePanel";

interface SidePanelSectionTemplateProps {
  fields: Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField | Section>;
  isInPageEditable: boolean;
  compact?: boolean;
  displayEmptyValues?: boolean;
}

const isSection = (field: InPageEditableSectionField | TwoColumnInPageEditableSectionField | Section): field is Section => {
  return "type" in field;
}

export const SidePanelSectionTemplate = (props: SidePanelSectionTemplateProps) => {
  const { layoutType } = useContext(SidePanelContext);

  const isFieldHidden = (field: InPageEditableSectionField | TwoColumnInPageEditableSectionField): boolean => {
    if (field.hidden) return true;
    if (!props.isInPageEditable && field.isEmpty && !props.displayEmptyValues) return true;

    return false;
  }

  const getVisibleFields = (): Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField> => {
    const sections = props.fields.filter((f): f is Section => isSection(f));
    const regularFields = props.fields.filter((f): f is InPageEditableSectionField | TwoColumnInPageEditableSectionField => !isSection(f));

    const result: Array<InPageEditableSectionField | TwoColumnInPageEditableSectionField> = [];

    if (sections.length > 0) {
      const visibleSections = sections
        .filter((section): section is FormSection => section.type !== "custom")
        .filter(section => !section.hidden)
        .filter(section => section.fields.some(f => !isFieldHidden(f)));

      result.push(...convertSectionsToSidePanel(visibleSections).filter(f => !isFieldHidden(f)));
    }

    result.push(...regularFields.filter(f => !isFieldHidden(f)));

    return result;
  }

  const visibleFields = getVisibleFields();

  if (layoutType === "narrow") {
    return <div className="side-panel-section-template-narrow-list">
      {flattenTwoColumnFields(visibleFields).map(field => <InPageEditableFieldSidePanelNarrow
        key={field.key}
        compact={props.compact}
        field={field}
      />)}
    </div>
  }

  return <div className="side-panel-section-template-grid">
    {visibleFields.map(field => <InPageEditableFieldSidePanelWide
      key={field.key}
      compact={props.compact}
      field={field}
    />)}
  </div>
}